module.exports = __webpack_public_path__ + "img/612.Appliances.b41ac9fe.svg";